<template>
	<div class="category-animation-2-bg abs">
		<transition name="fade-long">
			<div v-if="withFade" class="category-animation-2-bg__fade"></div>
		</transition>
		<video autoplay
			   muted
			   loop
			   playsinline
			   class="category-animation-2-bg__video"
			   @loadeddata="withFade=false">
			<source src="@/assets/animations/2/bg.mp4" type="video/mp4">
		</video>
	</div>
</template>

<script>
	export default {
		name: "category-animation-2-bg",
		components: {},
		data: () => {
			return {
				withFade: false,
			}
		},
		methods: {},
		mounted() {
		}
	}
</script>

<style lang="scss">
	.category-animation-2-bg {
		width: 800px;
		height: 100%;

		video {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

</style>